import * as React from "react";
import { FunctionComponent, useContext, useEffect, useRef } from "react";

//MUI Components
import Box from "@mui/material/Box";

//Custom components
import MapContext from "@/components/Map/MapContext";
import RadiusRuler from "./radiusRuler";
import { findControl, getDefinedOptions, getEvents } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";
import { ICrosshairRoot } from "@/@types/components/Map/Controls/Crosshair";
import Control from "ol/control/Control";

function RadiusRulerRoot(props: any) {
  const mapContext = useContext(MapContext) as MapContextType;

  const { id } = props;

  const radiusRulerRef = useRef(null);

  useEffect(() => {
    if (radiusRulerRef.current) {
      const options = {
        element: radiusRulerRef.current,
        target: mapContext.map?.getViewport()
      };

      const allOptions = Object.assign(options, props);
      const definedOptions = getDefinedOptions(allOptions);

      const events = {};

      const control = new RadiusRuler(definedOptions);

      if (id) {
        control.set("id", id);
      }

      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, RadiusRuler);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
        mapContext.map.addControl(control as Control);
      } else {
        mapContext.initOptions.controls.push(control as Control);
      }

      const olEvents = getEvents(events, props);
      for (const eventName in olEvents) {
        //@ts-ignore TODO:  Argument of type 'string' is not assignable to parameter of type '("error" | "change" | "propertychange")[]'
        control.on(eventName, olEvents[eventName]);
      }
    }

    return () => {
      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, RadiusRuler);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
      }
    };
  }, []);

  return (
    <Box id="radius-ruler-control" ref={radiusRulerRef}>
      {props.children}
    </Box>
  );
}

export default RadiusRulerRoot;
